function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnepaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 442.7493 194.7088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "type"
  }, /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_",
    "data-name": "type <CompoundPathItem>",
    d: "M22.5212,0C6.9361,0,0,5.9331,0,18.4v88.3928c0,12.3666,6.9361,18.3983,22.5212,18.3983,15.3843,0,22.3228-6.0317,22.3228-18.3983v-27.45H29.5585v32.6769H15.2819V66.7737H44.844V18.4C44.844,5.9331,37.9055,0,22.5212,0m7.0373,54.3062H15.2808V14.19H29.5585Z",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_PathItem_",
    "data-name": "type <PathItem>",
    d: "M106.958,1.017H77.1952V124.1858H92.4806V14.1894h14.2766V124.1858h15.282V17.307c0-10.9619-5.1274-16.29-15.0812-16.29",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_2",
    "data-name": "type <CompoundPathItem>",
    d: "M177.1472,0c-15.5838,0-22.5211,5.9331-22.5211,18.4v88.3928c0,12.3666,6.9373,18.3983,22.5211,18.3983,15.3841,0,22.3217-6.0317,22.3217-18.3983v-27.45H184.1855v32.6769H169.908V66.7737h29.5609V18.4C199.4689,5.9331,192.5313,0,177.1472,0m7.0383,54.3062H169.9077V14.19h14.2778Z",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_3",
    "data-name": "type <CompoundPathItem>",
    d: "M261.5119,1.0166H232.0511v123.17h15.2843v-31.68h14.1765c10.2559,0,15.3817-5.4293,15.3817-16.3885V17.3065q0-16.2893-15.3817-16.29m.101,78.3185H247.3351V14.19h14.2778Z",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_4",
    "data-name": "type <CompoundPathItem>",
    d: "M331.8486,0c-15.4839,0-22.5224,5.9331-22.5224,18.4v105.787h15.2831V79.2412h14.2766v44.9453H354.17V18.4C354.17,5.9331,347.2318,0,331.8486,0m7.0373,66.7737H324.6093V14.19h14.2766Z",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_5",
    "data-name": "type <CompoundPathItem>",
    d: "M431.4441,112.85V18.4C431.4441,5.9331,424.5069,0,409.1228,0c-15.4842,0-22.5212,5.9331-22.5212,18.4v87.3544c0,12.4372,7.009,18.3691,22.4188,18.3971l11.1212.0024,11.3025,11.304,11.3052-11.304ZM416.161,110.981H401.8833V14.1889H416.161Z",
    style: {
      fill: "#184180"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "tagline_CompoundPathItem_",
    "data-name": "tagline <CompoundPathItem>",
    d: "M0,154.98H13.5119a10.6987,10.6987,0,0,1,5.6373,1.2087,5.7547,5.7547,0,0,1,2.5491,3.266,18.7149,18.7149,0,0,1,.6269,5.3245,18.37,18.37,0,0,1-.6269,5.2112,5.9143,5.9143,0,0,1-2.5721,3.333,10.6016,10.6016,0,0,1-5.7056,1.2527H3.8466v11.1856H0Zm12.1243,16.0172a11.0264,11.0264,0,0,0,4.2495-.6039,3.0128,3.0128,0,0,0,1.7456-1.8563,13.0805,13.0805,0,0,0,.4029-3.7578,13.8562,13.8562,0,0,0-.3811-3.7589,2.9394,2.9394,0,0,0-1.6992-1.8578,10.89,10.89,0,0,0-4.2289-.6036H3.8466v12.4383Z",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "tagline_CompoundPathItem_2",
    "data-name": "tagline <CompoundPathItem>",
    d: "M30.1554,185.1573a4.6011,4.6011,0,0,1-2.617-3.2648,35.608,35.608,0,0,1-.56-7.54,35.5885,35.5885,0,0,1,.56-7.5385,4.6025,4.6025,0,0,1,2.617-3.266q2.056-.9625,6.8449-.9617,4.7422,0,6.8012.9617a4.6111,4.6111,0,0,1,2.6157,3.266,35.5664,35.5664,0,0,1,.56,7.5385,35.5859,35.5859,0,0,1-.56,7.54,4.61,4.61,0,0,1-2.6157,3.2648q-2.06.9621-6.8012.9616-4.7876,0-6.8449-.9616m11.3636-2.93a2.735,2.735,0,0,0,1.5446-2.1255,37.2393,37.2393,0,0,0,.29-5.7493,37.2073,37.2073,0,0,0-.29-5.748,2.7391,2.7391,0,0,0-1.5446-2.1267A12.0334,12.0334,0,0,0,37,165.8971a12.2131,12.2131,0,0,0-4.5406.5806,2.7239,2.7239,0,0,0-1.5664,2.1267,36.8441,36.8441,0,0,0-.2911,5.748,36.8757,36.8757,0,0,0,.2911,5.7493,2.72,2.72,0,0,0,1.5664,2.1255A12.2032,12.2032,0,0,0,37,182.8089a12.0235,12.0235,0,0,0,4.5187-.5817",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "tagline_PathItem_",
    "data-name": "tagline <PathItem>",
    points: "72.478 185.761 67.199 169.431 66.886 169.431 61.696 185.761 57.489 185.761 50.198 162.944 53.956 162.944 59.549 181.064 59.862 181.064 65.409 162.944 68.854 162.944 74.446 181.064 74.761 181.064 80.309 162.944 83.976 162.944 76.684 185.761 72.478 185.761",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "tagline_CompoundPathItem_3",
    "data-name": "tagline <CompoundPathItem>",
    d: "M106.4365,175.65H90.8222a16.8954,16.8954,0,0,0,.4466,4.6524,3.0151,3.0151,0,0,0,1.9466,1.9478,15.9271,15.9271,0,0,0,5.0323.5588,57.5528,57.5528,0,0,0,7.2942-.493v3.1772a36.6755,36.6755,0,0,1-3.7141.4478q-2.2806.1788-4.34.1777a16.1015,16.1015,0,0,1-6.7779-1.0724,5.2757,5.2757,0,0,1-2.841-3.4449,28.5381,28.5381,0,0,1-.6721-7.2041,31.1019,31.1019,0,0,1,.6039-7.1138,5.38,5.38,0,0,1,2.73-3.5349q2.1257-1.1613,6.733-1.1627,4.2947,0,6.2192,1.1406a5.1181,5.1181,0,0,1,2.4381,3.4451,36.1988,36.1988,0,0,1,.515,7.1809Zm-13.4451-9.2393a2.8319,2.8319,0,0,0-1.6993,1.9245,18.11,18.11,0,0,0-.47,4.5417h12.1243v-.3577a13.42,13.42,0,0,0-.5151-4.341,2.9082,2.9082,0,0,0-1.6774-1.8345,10.6491,10.6491,0,0,0-3.5786-.4466,12.207,12.207,0,0,0-4.184.5136",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "tagline_PathItem_2",
    "data-name": "tagline <PathItem>",
    d: "M112.5657,162.9442h3.2208l.18,4.3384h.2677a5.8164,5.8164,0,0,1,2.6854-3.6908,10.4125,10.4125,0,0,1,4.9216-1.0056v3.8918a9.7313,9.7313,0,0,0-4.7439.94,4.9019,4.9019,0,0,0-2.2813,2.8861,17.69,17.69,0,0,0-.6255,5.2563v10.201h-3.6252Z",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "tagline_PathItem_3",
    "data-name": "tagline <PathItem>",
    x: 138.7821,
    y: 154.9791,
    width: 3.8466,
    height: 30.7817,
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "tagline_PathItem_4",
    "data-name": "tagline <PathItem>",
    d: "M165.8058,172.92a17.8774,17.8774,0,0,0-.4029-4.5406,2.5991,2.5991,0,0,0-1.5216-1.8126,11.1733,11.1733,0,0,0-3.7578-.4466,7.4986,7.4986,0,0,0-4.1376.8947,3.8412,3.8412,0,0,0-1.6568,2.46,23.1025,23.1025,0,0,0-.3347,4.52v11.7663h-3.6252v-22.817h3.2223l.1789,3.22h.2677a5.3753,5.3753,0,0,1,2.5065-2.6609,11.1241,11.1241,0,0,1,5.0553-.9168,10.4708,10.4708,0,0,1,4.9886.9386,4.7009,4.7009,0,0,1,2.2592,2.7961,18.06,18.06,0,0,1,.5818,5.1675v14.2728h-3.6237Z",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "tagline_PathItem_5",
    "data-name": "tagline <PathItem>",
    d: "M191.7315,185.9409q-3.02-.1806-5.3475-.448v-3.5338q5.8173.5809,9.7092.5806a28.5554,28.5554,0,0,0,3.8259-.2007,7.06,7.06,0,0,0,2.3932-.7376,2.49,2.49,0,0,0,1.1624-1.5886,11.6327,11.6327,0,0,0,.2692-2.7976,13.617,13.617,0,0,0-.2229-2.9738,1.8865,1.8865,0,0,0-1.0516-1.2757,8.9145,8.9145,0,0,0-2.8413-.5818l-7.6067-.85a8.9441,8.9441,0,0,1-4.1817-1.3209,4.776,4.776,0,0,1-1.8793-2.6391,15.8514,15.8514,0,0,1-.47-4.2725,9.9134,9.9134,0,0,1,1.2745-5.5474,6.1068,6.1068,0,0,1,3.5786-2.5062,24.5029,24.5029,0,0,1,6.1973-.627q2.595,0,5.28.2241a40.0381,40.0381,0,0,1,4.2495.5366v3.4q-1.7-.2666-4.2058-.4236t-4.6524-.157a28.7488,28.7488,0,0,0-4.027.224,6.1708,6.1708,0,0,0-2.3714.7607,2.4427,2.4427,0,0,0-1.2075,1.4315,9.3543,9.3543,0,0,0-.2689,2.55,9.4586,9.4586,0,0,0,.2689,2.6624,1.9746,1.9746,0,0,0,1.03,1.2075,7.7782,7.7782,0,0,0,2.5041.56l7.5168.85a13.6632,13.6632,0,0,1,4.1606.9386,4.1376,4.1376,0,0,1,2.1485,2.4178,15.3723,15.3723,0,0,1,.6258,5.1441,11.5991,11.5991,0,0,1-1.2527,6.0621,5.577,5.577,0,0,1-3.356,2.5514,23.5258,23.5258,0,0,1-5.7711.5576q-2.4618,0-5.48-.1777",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "tagline_PathItem_6",
    "data-name": "tagline <PathItem>",
    d: "M229.2918,172.92a17.8774,17.8774,0,0,0-.4029-4.5406,2.5985,2.5985,0,0,0-1.5216-1.8126,11.1722,11.1722,0,0,0-3.7577-.4466,7.4992,7.4992,0,0,0-4.1377.8947,3.8414,3.8414,0,0,0-1.6567,2.46,23.0946,23.0946,0,0,0-.3347,4.52v11.7663h-3.6253V152.5185h3.6253v13.4229h.2228a4.9559,4.9559,0,0,1,2.4381-2.4611,11.4755,11.4755,0,0,1,4.9446-.85,10.6854,10.6854,0,0,1,4.9886.9176,4.6118,4.6118,0,0,1,2.2592,2.7731,18.06,18.06,0,0,1,.5818,5.1675v14.2728h-3.6238Z",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "tagline_CompoundPathItem_4",
    "data-name": "tagline <CompoundPathItem>",
    d: "M240.3413,184.665q-1.7878-1.4535-1.79-5.1675a10.83,10.83,0,0,1,.6269-4.1169,3.9935,3.9935,0,0,1,2.1255-2.1462,10.6455,10.6455,0,0,1,4.2277-.6718q1.2981,0,8.5453.2252v-1.3439a9.9419,9.9419,0,0,0-.5147-3.8029,2.5616,2.5616,0,0,0-1.8785-1.4316,23.578,23.578,0,0,0-4.63-.3128q-1.4315,0-3.602.1558t-3.3781.3374v-3.1787a48.147,48.147,0,0,1,8.2764-.6242,16.56,16.56,0,0,1,6.0185.8265,4.5121,4.5121,0,0,1,2.6621,2.6842,16.678,16.678,0,0,1,.6709,5.3912v14.273h-3.266l-.1792-3.1771h-.2689a4.8967,4.8967,0,0,1-3.019,2.841,15.5613,15.5613,0,0,1-4.8994.6939q-3.9369,0-5.7274-1.4546m10.7609-2.2143a3.1887,3.1887,0,0,0,2.0354-1.5656,8.9182,8.9182,0,0,0,.94-4.4747v-1.03h-7.6055a10.222,10.222,0,0,0-2.7513.2692,1.8985,1.8985,0,0,0-1.2305,1.0516,6.212,6.212,0,0,0-.3581,2.4381,5.2963,5.2963,0,0,0,.403,2.3725,2.2219,2.2219,0,0,0,1.4973,1.05,14.5322,14.5322,0,0,0,3.4243.2911,13.59,13.59,0,0,0,3.6459-.4029",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "tagline_CompoundPathItem_5",
    "data-name": "tagline <CompoundPathItem>",
    d: "M264.86,162.9445h3.2208l.18,3.22h.268a5.03,5.03,0,0,1,2.841-2.8182,12.87,12.87,0,0,1,4.6745-.76,10.5815,10.5815,0,0,1,5.19,1.0275,5.6948,5.6948,0,0,1,2.5284,3.5131,26.6632,26.6632,0,0,1,.7388,7.1808,27.1472,27.1472,0,0,1-.7388,7.2478,5.7218,5.7218,0,0,1-2.5051,3.5337,10.3239,10.3239,0,0,1-5.1226,1.03,13.0619,13.0619,0,0,1-4.7206-.7157,4.9923,4.9923,0,0,1-2.7072-2.5063h-.2241v11.8114H264.86Zm13.8917,19.1031a3.0158,3.0158,0,0,0,1.6556-2.1925,35.8613,35.8613,0,0,0,0-11.0055,3.0891,3.0891,0,0,0-1.6556-2.2141,10.8735,10.8735,0,0,0-4.1376-.56,8.7,8.7,0,0,0-3.625.6266,3.5934,3.5934,0,0,0-1.8784,1.9236,7.7616,7.7616,0,0,0-.5148,2.2823q-.1116,1.2986-.1122,3.4451,0,2.1908.09,3.4449a6.644,6.644,0,0,0,.4469,2.1022,3.7241,3.7241,0,0,0,1.9244,2.0585,8.8048,8.8048,0,0,0,3.669.6257,11.3073,11.3073,0,0,0,4.1376-.5369",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "tagline_CompoundPathItem_6",
    "data-name": "tagline <CompoundPathItem>",
    d: "M308.9287,175.65H293.3144a16.8954,16.8954,0,0,0,.4466,4.6524,3.0151,3.0151,0,0,0,1.9466,1.9478,15.9267,15.9267,0,0,0,5.0323.5588,57.55,57.55,0,0,0,7.2941-.493v3.1772a36.673,36.673,0,0,1-3.714.4478q-2.2806.1788-4.34.1777a16.1015,16.1015,0,0,1-6.7779-1.0724,5.2757,5.2757,0,0,1-2.841-3.4449,28.5381,28.5381,0,0,1-.6721-7.2041,31.1019,31.1019,0,0,1,.6039-7.1138,5.38,5.38,0,0,1,2.73-3.5349q2.1257-1.1613,6.733-1.1627,4.2947,0,6.2191,1.1406a5.1175,5.1175,0,0,1,2.4381,3.4451,36.197,36.197,0,0,1,.5151,7.1809Zm-13.4451-9.2393a2.8319,2.8319,0,0,0-1.6993,1.9245,18.11,18.11,0,0,0-.47,4.5417h12.1242v-.3577a13.4231,13.4231,0,0,0-.515-4.341,2.9076,2.9076,0,0,0-1.6774-1.8345,10.6491,10.6491,0,0,0-3.5786-.4466,12.207,12.207,0,0,0-4.184.5136",
    style: {
      fill: "#184180"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "tagline_PathItem_7",
    "data-name": "tagline <PathItem>",
    x: 324.6093,
    y: 182.8525,
    width: 106.836,
    height: 2.9083,
    style: {
      fill: "#ee263e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnepaq);
export default __webpack_public_path__ + "static/media/enepaq.691db0f34dd9d12d9839d184558f7584.svg";
export { ForwardRef as ReactComponent };